import { ReactElement } from 'react';
import { FormatOptionLabelMeta } from 'react-select/base';
import { Icon, IconName } from '../../Graphics';
import { ValueLabelOption } from './types';
import styles from './styles.module.scss';

type OptionWithCheckIconProps = {
  formattedLabel: ReactElement;
  isSelected: boolean;
};

const OptionWithCheckIcon = ({ formattedLabel, isSelected }: OptionWithCheckIconProps) => (
  <div className={styles.optionLabel}>
    {isSelected ? (
      <div className={styles.selectedIcon}>
        <Icon name={IconName.Check} size="0.75em" strokeWidth={2.5} />
      </div>
    ) : (
      <div className={styles.notSelectedPlaceholder} />
    )}
    <div className={styles.labelContainer}>{formattedLabel}</div>
  </div>
);

export const prefixMenuOptionsWithCheckIcon =
  <Option extends ValueLabelOption, IsMulti extends boolean = false>(
    FormattedLabel?: (props: Option) => ReactElement
  ) =>
  (option: Option, { context, selectValue }: FormatOptionLabelMeta<Option>) => {
    const label = FormattedLabel ? <FormattedLabel {...option} /> : <>{option.label}</>;

    const isSelected = (selectValue || []).find((_: Option) => _.value === selectValue) !== undefined;

    if (context === 'menu') return <OptionWithCheckIcon formattedLabel={label} isSelected={isSelected} />;

    return label;
  };
